/**
 * Passkey intelligence — query hook.
 *
 * Backed by internal/ops/report.PasskeyHandler, mounted at
 * /api/v1/tenants/{tenant_id}/reports/passkey-intelligence
 * via WithPathTenant.
 */

import { useQuery } from "@tanstack/react-query";
import { apiFetch, type ApiError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import { passkeyOverviewSchema, type PasskeyOverview } from "./schemas";

export async function fetchPasskeyOverview(
  tenantID: string,
): Promise<PasskeyOverview> {
  const raw = await apiFetch<unknown>(
    `/api/v1/tenants/${encodeURIComponent(tenantID)}/reports/passkey-intelligence`,
  );
  return passkeyOverviewSchema.parse(raw);
}

export function usePasskeyOverviewQuery(tenantID: string) {
  return useQuery<PasskeyOverview, ApiError>({
    queryKey: queryKeys.passkeyIntelligence.overview(tenantID),
    queryFn: () => fetchPasskeyOverview(tenantID),
    enabled: tenantID.length > 0,
    staleTime: 5 * 60_000,
  });
}
